import {fetchAndDeserialize, serialize} from '../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent} from '../../util/fetch';
import {PaginationDataType} from '../../util/pagination-hook/pagination-hook-type';
import {objectToUrlParameters} from '../../util/url';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../api/api-const';
import {generateResponseSchema, PaginatedResponseType} from '../api/api-type';

import {
    CreateWebhookIntegrationType,
    UpdateWebhookIntegrationType,
    webhookIntegrationItemSchema,
    WebhookIntegrationItemType,
    webhookIntegrationTypeItemSchema,
    WebhookIntegrationTypeItemType,
} from './webhook-integration-type';

export function fetchIntegrationWebhooks(
    options: PaginationDataType & {
        webhookTypeCode: string;
    }
): Promise<PaginatedResponseType<WebhookIntegrationItemType>> {
    return fetchAndDeserialize<PaginatedResponseType<WebhookIntegrationItemType>>(
        `/cp/webhooks/?${objectToUrlParameters({
            page: options.page,
            page_size: options.pageSize,
            code: options.webhookTypeCode,
        })}`,
        generateResponseSchema(webhookIntegrationItemSchema),
        {
            fetchOptions: {skipCache: true},
        }
    );
}

export function fetchIntegrationWebhook(webhookId: number): Promise<WebhookIntegrationItemType> {
    return fetchAndDeserialize<WebhookIntegrationItemType>(
        `/cp/webhooks/${webhookId}/`,
        generateResponseSchema(webhookIntegrationItemSchema),
        {
            fetchOptions: {skipCache: true},
        }
    );
}

export function createIntegrationWebhook(data: CreateWebhookIntegrationType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/webhooks/`, {
        method: FetchMethodEnum.post,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function updateIntegrationWebhook(data: UpdateWebhookIntegrationType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/webhooks/${data.id}/`, {
        method: FetchMethodEnum.patch,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function deleteIntegrationWebhook(id: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/webhooks/${id}/`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function fetchWebhookIntegrationTypes(): Promise<PaginatedResponseType<WebhookIntegrationTypeItemType>> {
    return fetchAndDeserialize<PaginatedResponseType<WebhookIntegrationTypeItemType>>(
        `/cp/webhooks/types/`,
        generateResponseSchema(webhookIntegrationTypeItemSchema),
        {
            fetchOptions: {skipCache: true},
        }
    );
}
